import React from 'react';

const StatsBand = () => {
  return (
    <div className="stats-band">
      <div className="stats-inner">
        <div className="band-stat"><span className="band-num">20–40%</span><span className="band-label">Valuation uplift potential with preparation</span></div>
        <div className="band-stat"><span className="band-num">10</span><span className="band-label">Value Maximizers assessed, tracked &amp; actioned</span></div>
        <div className="band-stat"><span className="band-num">5</span><span className="band-label">Integrated modules — one complete operating system</span></div>
        <div className="band-stat"><span className="band-num">85%</span><span className="band-label">Of deal failures are preventable with preparation</span></div>
      </div>
    </div>
  );
};

export default StatsBand;
